import { connect } from 'react-redux';
import AdminPanelStockForm from './AdminPanelStockForm';

import * as AdminLoginActions from './AdminPanelStockActionCreator';

const mapStateToProps = (state) => {
  const auth =
    state.get('auth') && state.get('auth').toJS && state.get('auth').toJS();
  const kiosk = state.get('kiosk');
  return {
    ...auth,
    ...kiosk
  };
};

const mapDispatchToProps = {
  ...AdminLoginActions
};

const AdminPanelStockFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminPanelStockForm);

export default AdminPanelStockFormContainer;
